// extracted by mini-css-extract-plugin
module.exports = {"cardExplore":"styles_cardExplore__nsZqQ","cardBuild":"styles_cardBuild__2XQej","card":"styles_card__2Ozhf"};